import { Reducer } from "redux";

import { IntegrationErrorsAction, IntegrationErrorsActionTypes, IntegrationErrorsState } from "./types";

const initialState: IntegrationErrorsState = {
  count: 0,
  items: [],
  dataIsLoading: false,
  chartItems: [],
  chartDataIsLoading: false,
  samples: {
    unknownError: null,
    internalError: null,
    parseError: null,
    timeoutError: null,
    partnerError: null,
    requestError: null,
  },
  samplesIsLoading: false,
};

const reducer: Reducer<IntegrationErrorsState, IntegrationErrorsAction> = (state = initialState, action) => {
  switch (action.type) {
    case IntegrationErrorsActionTypes.TABLE_FETCH_REQUEST:
      return { ...state, dataIsLoading: true };

    case IntegrationErrorsActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, items: results, dataIsLoading: false };
    }

    case IntegrationErrorsActionTypes.TABLE_FETCH_ERROR:
      return { ...state, dataIsLoading: false };

    case IntegrationErrorsActionTypes.CHART_FETCH_REQUEST:
      return { ...state, chartDataIsLoading: true };

    case IntegrationErrorsActionTypes.CHART_FETCH_SUCCESS:
      return { ...state, chartItems: action.payload, chartDataIsLoading: false };

    case IntegrationErrorsActionTypes.CHART_FETCH_ERROR:
      return { ...state, chartDataIsLoading: false };

    case IntegrationErrorsActionTypes.SAMPLES_FETCH_REQUEST:
      return { ...state, samplesIsLoading: true };

    case IntegrationErrorsActionTypes.SAMPLES_FETCH_SUCCESS:
      return { ...state, samples: { ...state.samples, ...action.payload }, samplesIsLoading: false };

    case IntegrationErrorsActionTypes.SAMPLES_FETCH_ERROR:
      return { ...state, samplesIsLoading: false };

    default:
      return state;
  }
};

export default reducer;
